import { ModuleRegistry } from "seneca-common/features/module/registry";

import { generateInitialUserAnswer, markAnswer } from "./logic/answers";
import { getModuleAssets, transformModuleAssets } from "./logic/assets";
import { generateContent } from "./logic/content";
import { canBeTested } from "./logic/tested";

export const MODULE_TYPE = "image-description";
export type TYPE = "image-description";
export { transformModuleAssets };

export const register = (moduleRegistry: ModuleRegistry) =>
  moduleRegistry
    .buildModule(MODULE_TYPE)
    .with.logic()
    .markAnswer(markAnswer)
    .generateContent(generateContent)
    .getModuleAssets(getModuleAssets)
    .generateInitialUserAnswer(generateInitialUserAnswer)
    .canBeTested(canBeTested)
    .back.staticInformation()
    .displayName("Image Description")
    .root.register();
